import React, { Fragment, useEffect, useRef } from 'react';
import d20logo from '../../dice-d20-svgrepo-com.svg'
import HpModal from './HpModal';
import { EncounterStats } from '../../Types/TableTypes';
import RowContextMenu from './RowContextMenu';

interface TableRowTopComponentProps {
    row: EncounterStats,
    index: number,
    isPlayer: boolean,
    initiativeBonus: number,
    updateRow: (row: EncounterStats)=>void 
    deleteRow: (index: number)=>void 
    duplicateRow: (index: number)=>void 
    updateIndex: (index: number, delta: number)=>void 
    isCurrentTurn: boolean
    editMode: boolean,
    updateExpanded: (expanded: boolean) => void
    // expanded: boolean
}

const TableRowTopComponent = (props: TableRowTopComponentProps)=>{
    const [isHpModalopen, setIsHpModalopenOpen] = React.useState(false);
    const row = useRef<HTMLTableRowElement>(null);
    useEffect(() => {
        if (props.isCurrentTurn){
            // row.current?.focus();
            row.current?.scrollIntoView({block: "start", inline: "nearest", behavior: "smooth"});
        }
    },[props.isCurrentTurn])
    // console.log(props.row);
    return(
        <tr ref={row} tabIndex={0}
            className={"table-row "+(props.isCurrentTurn && props.row.hp === 0 ? " table-warning " : props.isCurrentTurn && props.row.hp !== 0 ? " table-success " : !props.isCurrentTurn && props.row.hp === 0 ? " table-danger " : "")}>
            {/* (props.isCurrentTurn ? "table-success" : "") +" "+ (props.row.hp === 0 ? "table-danger" : "")}> */}
            <td style={{width: "3%", minWidth: "32px"}}>
                {(props.editMode || !props.isPlayer) &&<>
                {props.row.expanded && <span onClick={e=>{props.updateExpanded(false); }} role="button" >
                    <i key={props.index+"caret-up"} className="bi bi-caret-up-fill"></i>
                </span>}
                {!props.row.expanded && <span onClick={e=>{props.updateExpanded(true); }} role="button" >
                    <i key={props.index+"caret-up"} className="bi bi-caret-down-fill"></i>
                </span>}
                </>}
            </td>
            <td style={{width: "10%", minWidth: "128px"}}>
                <div style={{display: "flex"}}>
                    <input 
                        name="initiative" 
                        type="number" 
                        value={props.row.initiative}
                        onChange={e => {
                            props.row.initiative = parseInt(e.target.value); 
                            props.updateRow(props.row);
                        }}
                    ></input>
                    <span role="button" onClick={e=>{
                            props.row.initiative = Math.floor(Math.random() * 20) + 1 + props.initiativeBonus;
                            props.updateRow(props.row);
                        }}>
                        <img src={d20logo} className="d20-logo" alt="logo" />
                        {/* <i className="bi bi-dice-3"></i> */}
                    </span>
                </div>
            </td>
            <td style={{width: "25%"}}>
                <input 
                    name="creature-name" 
                    type="text" 
                    value={props.row.name}
                    onChange={e => {
                        props.row.name = e.target.value;
                        props.updateRow(props.row);

                    }}
                ></input>
            </td>
            <td style={{width: "15%", minWidth: "210px"}}>
                <div className='d-flex flex-wrap justify-content-center'>
                    <span>
                        <input 
                            style={{width:"52px", textAlign:"end"}}
                            name="hp" 
                            type="number" 
                            value={props.row.hp}
                            onChange={e => {
                                props.row.hp = parseInt(e.target.value);
                                props.updateRow(props.row);
                            }}
                        ></input>
                        /
                        <input 
                            style={{width:"52px", textAlign:"start"}}
                            name="max-hp" 
                            type="number" 
                            value={props.row.maxHp}
                            onChange={e => {
                                props.row.maxHp = parseInt(e.target.value);
                                props.updateRow(props.row);
                            }}
                        ></input>
                    </span>
                    <span>
                        +
                        <input 
                            style={{width: "52px"}}
                            name="temp-hp" 
                            type="number" 
                            value={props.row.tempHp}
                            onChange={e => {
                                props.row.tempHp = (parseInt(e.target.value));
                                props.updateRow(props.row);
                            }}
                        ></input>
                    </span>
                </div>
            </td>
            <td className="bg-secondary-subtle" role="button" style={{width: "64px"}}>
                <span  onClick={e=>setIsHpModalopenOpen(true)}><i className="bi bi-plus-slash-minus"></i></span>
                <HpModal isOpen={isHpModalopen} onClose={()=>setIsHpModalopenOpen(false)} 
                    handleHeal={(num: number)=>{
                        setIsHpModalopenOpen(false);
                        if (props.row.hp + num > props.row.maxHp){
                            props.row.hp = props.row.maxHp;
                        } 
                        else{
                            props.row.hp += num;
                        }
                        props.updateRow(props.row);
                    }}
                    handleDamage={(num: number)=>{
                        setIsHpModalopenOpen(false);

                        if (props.row.tempHp - num > 0){
                            props.row.tempHp -= num;
                        }else{
                            if (props.row.tempHp - num < 0 && props.row.tempHp > 0){
                                props.row.hp -= (num - props.row.tempHp);     
                                props.row.tempHp = 0;
                            }
                            else{
                                props.row.hp -= num;
                            }               
                        }
                        if (props.row.hp < 0) props.row.hp=0;
                        props.updateRow(props.row);
                    }}    
                />
            </td>
            <td style={{width: "5%", minWidth: "72px"}}>
                <input 
                    name="ac" 
                    type="number" 
                    value={props.row.ac}
                    onChange={e => {
                        props.row.ac = (parseInt(e.target.value));
                        props.updateRow(props.row);
                    }}
                ></input>
            </td>
            <td style={{width: "auto"}}>
                <input 
                    name="conditions" 
                    type="text" 
                    value={props.row.conditions}
                    onChange={e => {
                        props.row.conditions = (e.target.value);
                        props.updateRow(props.row);
                    }}
                ></input>
            </td>
            <td style={{width: "5%", minWidth: "64px"}}>
                <span>
                    <input 
                        name="reaction" 
                        type="checkbox"
                        className='form-check-input'
                        style={{maxWidth: "24px", maxHeight: "24px", outlineStyle:"auto", outlineColor: "darkgray"}}
                        checked={props.row.reaction}
                        onChange={e => {
                            props.row.reaction = (e.target.checked);
                            props.updateRow(props.row);
                        }}
                    ></input>
                </span>
            </td>
            
            <td style={{width: "2%", minWidth: "32px"}}>
                <RowContextMenu editMode={props.editMode} rowIndex={props.index} updateIndex={props.updateIndex} duplicateRow={props.duplicateRow} deleteRow={props.deleteRow}/>
            </td>
            
        </tr>            
    );

    // function updateCreatureStats(stats:CreatureStats){
    //     props.row.creatureStats = stats;
    //     props.updateRow(props.row);
    // }
}

export default TableRowTopComponent;